module.exports = __webpack_public_path__ + "img/editApplyPhone.0c989218.png";